angular
	.module 'App.Repository'
	.factory 'BulkDataLogRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class BulkDataLogRepository extends BaseRepository
				@resource = '/bulk_data_logs'
				@isRestricted = true

			return new BulkDataLogRepository()
		]
